<div id="search-history" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    person
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">Search history</span>
            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper  mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter placeholder="Search">
                </div>
            </div>
            <!-- / SEARCH -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <mat-table class="search-history-table"
                       #table [dataSource]="dataSource"
                       matSort
                       [@animateStagger]="{value:'50'}"
                       fusePerfectScrollbar>
                <!-- ID Column -->
                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch">
                        <p class="text-truncate">{{userSearch.id}}</p>
                    </mat-cell>
                </ng-container>
                <!-- First name Column -->
                <ng-container matColumnDef="pol">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>POL</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch">
                        <p class="text-truncate">{{userSearch.search.pol}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="pod">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>POD</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch">
                        <p class="text-truncate">{{userSearch.search.pod}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="unit">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>Unit</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch" fxHide fxShow.gt-sm>
                        <p class="text-truncate">{{userSearch.search.unit}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="type">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>Type</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch" fxHide fxShow.gt-sm>
                        <p class="text-truncate">{{userSearch.search.type}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="etd">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>Etd</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch" fxHide fxShow.gt-sm>
                        <p class="text-truncate">{{userSearch.search.etd | date : "MM/dd/yy"}}</p>
                    </mat-cell>
                </ng-container>
                <!-- Last name Column -->
                <ng-container matColumnDef="search_at">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Search time</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch">
                        <p class="text-truncate">{{userSearch.search_at | date : "MM/dd hh:mm"}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                    <mat-cell *matCellDef="let userSearch">
                        <button mat-flat-button color="accent" (click)="search(userSearch)">Retry</button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let userSearch; columns: displayedColumns;"
                         class="search-history"
                         matRipple>
                </mat-row>
            </mat-table>

            <mat-paginator #paginator
                           [length]="dataSource.filteredData.length"
                           [pageIndex]="0"
                           [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]">
            </mat-paginator>

        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
